import React from "react";

import Box from "../Box";

const Header = props => {
  return (
    <section className="hp__block hp__block--title hp__block--title container-fluid">
      <Box {...props} id="b1" type="title" settings={props.settings.b1} />
    </section>
  );
};

export default Header;
